module.exports = __webpack_public_path__ + "img/noFeedback.01c27a55.svg";